module.exports = __webpack_public_path__ + "img/img62.0ed11003.svg";